<template>
  <div class="wrapper pricing">
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/bg37.jpg')"
      />
      <div class="content-center">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <h1 class="title">
              Was könnte mich das kosten?
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="pricing-4">
        <div class="container">
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto text-center">
              <h4 class="description">
                123db zeichnet sich durch seine Anpassungsfähigkeit aus. Wir wollen ebenfalls keine Dienstleistung von der Stange anbieten, sondern Ihnen
                ein ERP System maßschneidern, das Ihnen und Ihren Mitarbeitern jeden Tag Freude bereitet.
                <br />Sei es durch die einfache Bedienbarkeit,
                durch die zahlreichen Integrationen oder aufgrund des starken Reportings, weil alle Daten in Ihrer 123db zusammenlaufen.
                <br /><br />Hier finden Sie vorgefertigte Projektpakete, die wir aber in jedem Fall gemeinsam an Ihr Unternehmen und Ihre Anforderungen anpassen werden.
              </h4>
              <div class="section-space" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <card
                type="pricing"
                plain
              >
                <h6 class="category">
                  Das Wesentliche
                </h6>
                <div class="icon icon-info">
                  <i class="now-ui-icons business_briefcase-24" />
                </div>
                <h3 class="card-title">
                  <small>€</small>
                  3.000
                </h3>
                <ul>
                  <li>Installation und Einrichtung</li>
                  <li>Cloud oder On-Premises</li>
                  <li>Wartungsvertrag nach Wunsch</li>
                  <li>ab 0,-/Monat laufenden Kosten wenn Sie es selbst hosten</li>
                </ul>
                <n-button
                  type="info"
                  round
                  @click="scrollToContactForm"
                >
                  Anfragen
                </n-button>
              </card>
            </div>
            <div class="col-md-4">
              <card
                type="pricing"
                color="black"
              >
                <h6 class="category">
                  Professionell angepasst
                </h6>
                <div class="icon icon-success">
                  <i class="now-ui-icons design-2_ruler-pencil" />
                </div>
                <h3 class="card-title">
                  <small>€</small>
                  ab 8.000
                </h3>
                <ul>
                  <li>Das Wesentliche</li>
                  <li>Anpassungen im Rahmen von<br />50 Regiestunden</li>
                  <li>Individuelle PDF-Vorlagen</li>
                  <li>bis zu zwei Zusatzpakete:<br />Sales und/oder<br />Reporting und Workflows<br />je nach Bedarf *</li>
                </ul>
                <n-button
                  type="default"
                  round
                  @click="scrollToContactForm"
                >
                  Anfragen
                </n-button>
              </card>
            </div>
            <div class="col-md-4">
              <card
                type="pricing"
                plain
              >
                <h6 class="category"> 
                  Maßgeschneidert
                </h6>
                <div class="icon icon-danger">
                  <i class="now-ui-icons design_palette" />
                </div>
                <h3 class="card-title">
                  <small>€</small>
                  15.000
                </h3>
                <ul>
                  <li>Anpassungen im Rahmen von<br />120 Regiestunden</li>
                  <li>Modul Eingangsrechnungen</li>
                  <li>Modul Bankdatenabgleich</li>
                  <li>Zusatzpakete Sales, Reporting und Workflows (nach Bedarf) *</li>
                  <li>Integrationen und Schnittstellen</li>
                </ul>
                <n-button
                  type="danger"
                  round
                  @click="scrollToContactForm"
                >
                  Anfragen
                </n-button>
              </card>
            </div>
          </div>
        </div>
      </div>
      <div class="section section-frequently">
        <div class="container">
          <div class="text-center">
            <h3 class="title">
              Frequently Asked Questions
            </h3>
          </div>
          <div class="row">
            <div class="col-md-8 mr-auto">
              <info-section
                type="success"
                icon="now-ui-icons shopping_box"
                title='Ich brauche kein "Modul Eingangsrechnung", oder ich hätte gerne "Sales", brauche aber sonst nur das Wesentliche. Geht das?'
                description="Selbstverständlich. Die Pakete dienen lediglich der Orientierung. Wieviel ein Start mit 123db für Sie konkret kosten wird stimmen wir gemeinsam ab. Sie brauchen sich nicht den Kopf über PDF-Vorlagen zerbrechen, die Sie nicht brauchen."
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 ml-auto">
              <info-section
                type="info"
                icon="now-ui-icons shopping_credit-card"
                title="Entstehen laufende Kosten?"
                description='Jein. Für 123db an sich fallen keine laufenden Kosten an. Für Hosting können Gebühren anfallen, z.B. bei Cloud-Hosting oder wenn wir das Hosting für Sie betreuen. In diesem Fall werden wir Ihnen einen Wartungsvertrag anbieten. Weiters können jährlich Lizenzkosten für die Zusatzpakete "Sales" und "Reporting und Workflows" anfallen. Aber keine Sorge, wir gehen alles je nach Anforderung mit Ihnen durch.'
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 mr-auto">
              <info-section
                type="success"
                icon="now-ui-icons business_money-coins"
                title="Hier steht etwas von Wartungsvertrag, was erwartet mich?"
                description="Erfahrungsgemäß möchten sich Kunden von 123db nicht um Hosting oder Updates kümmern. Außerdem kommen im Laufe des Arbeitsalltags immer wieder Ideen auf, um sich eine Aufgabe zu erleichtern. Sie erhalten in unseren Wartungsverträgen immer einige Regiestunden für Anpassungen dazu. Der Einsatz von 123db und ein Wartungsvertrag sind natürlich auch einzeln erhältlich :)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="container description">
        * laufende Lizenzkosten für die ersten zwei Jahre sind mitinbegriffen - ab dann fallen für jedes Zusatzpaket Kosten gem. der
        <a href="https://www.espocrm.com/extensions/" target="_blank">
        Preisliste des Herstellers an.
        </a>
        <br />
        &nbsp;
      </div>

      <div
        class="contactus-1 section-image"
        style="background-image: url('img/contact1.jpg')"
      >
        <div class="container">
          <div class="row">
            <div class="col-md-5">
              <h2 class="title">
                Mehr erfahren
              </h2>
              <h4 class="description">
                Schreiben Sie uns eine Nachricht, oder rufen Sie uns an. Wir beantworten Ihre Anfrage innerhalb von 24 Stunden.
              </h4>
              <info-section
                  type="primary"
                  icon="business_briefcase-24 now-ui-icons"
              >
                <h4 class="info-title">
                  Firmendaten
                </h4>
                <p class="description">
                  <a href="https://www.boigner.digital" target="_blank" @click.prevent="redirect('bdweb')">
                    Boigner Digital GmbH
                  </a>
                  <br /> Kaisersteig 4/2/3
                  <br />A-2380 Perchtoldsdorf
                </p>
              </info-section>
              <info-section
                type="primary"
                icon="now-ui-icons tech_mobile"
              >
                <h4 class="info-title">
                  Telefonischer Kontakt
                </h4>
                <p class="description">
                  Thomas Boigner, MSc
                  <br><a href="tel:+4366475069874">+43 664 750 698 74</a>
                  <br>Mo. - Fr., 09:00-17:00
                </p>
              </info-section>
            </div>
            <div id="contactUs" class="col-md-5 ml-auto mr-auto">
              <card
                type="contact"
                raised
                header-classes="text-center"
              >
                <h4
                  slot="header"
                  class="card-title"
                >
                  Schreiben Sie uns Ihr Anliegen:
                </h4>

                <form
                  id="contact-form"
                  role="form"
                  method="post"
                  @submit.prevent="onSubmit"
                  v-if="!formSubmitted"
                >
                  <label>Ihr Vorname</label>
                  <fg-input
                      v-model="form.firstName"
                      placeholder="Ihr Vorname..."
                      addon-left-icon="now-ui-icons users_circle-08"
                  />
                  <div v-if="errors.firstName" style="color:red; font-size:0.9em;">
                    {{ errors.firstName }}
                  </div>
                  <label>Ihr Nachname</label>
                  <fg-input
                      v-model="form.lastName"
                      placeholder="Ihr Nachname..."
                      addon-left-icon="now-ui-icons users_circle-08"
                  />
                  <div v-if="errors.lastName" style="color:red; font-size:0.9em;">
                    {{ errors.lastName }}
                  </div>
                  <label>Ihre Mailadresse</label>
                  <fg-input
                      v-model="form.email"
                      placeholder="Ihre Mailadresse..."
                      addon-left-icon="now-ui-icons users_circle-08"
                  />
                  <div v-if="errors.emailPhone" style="color:red; font-size:0.9em;">
                    {{ errors.emailPhone }}
                  </div>
                  <label>Ihre Telefonnummer (falls Sie lieber zurückgerufen werden wollen)</label>
                  <fg-input
                      v-model="form.phone"
                      placeholder="Ihre Telefonnummer (optional)..."
                      addon-left-icon="now-ui-icons tech_mobile"
                  />
                  <div v-if="errors.emailPhone" style="color:red; font-size:0.9em;">
                    {{ errors.emailPhone }}
                  </div>
                  <div class="form-group">
                    <label>Ihr Anliegen</label>
                    <textarea
                        id="message"
                        name="message"
                        class="form-control"
                        rows="6"
                        v-model="form.message"
                    ></textarea>
                  </div>
                  <div v-if="errors.message" style="color:red; font-size:0.9em;">
                    {{ errors.message }}
                  </div>
                  <div class="submit text-center">
                    <n-button
                        type="primary"
                        round
                        native-type="submit"
                    >
                      Nachricht schicken
                    </n-button>
                  </div>
                </form>
                <div v-else class="text-center">
                  <h3>Danke für Ihre Nachricht!</h3>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card, Button, InfoSection, FormGroupInput, Checkbox } from '@/components';

  export default {
    name: 'PricingPage',
    bodyClass: 'pricing',
    components: {
      Card,
      InfoSection,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: ''
      },
      errors: {
        firstName: '',
        lastName: '',
        emailPhone: '',
        message: ''
      },
      formSubmitted: false,
      formSubmitting: false,
      redirecting: false,
      options: {}
    }
  },
  methods: {
    validateForm() {
      this.errors.emailPhone = '';
      this.errors.message = '';
      this.errors.firstName = '';
      this.errors.lastName = '';

      if (!this.form.firstName || this.form.firstName.trim().length < 2) {
        this.errors.firstName = 'Bitte geben Sie Ihren Vornamen ein.';
      }

      if (!this.form.lastName || this.form.lastName.trim().length < 2) {
        this.errors.lastName = 'Bitte geben Sie Ihren Nachnamen ein.';
      }

      if (!this.form.email.trim() && !this.form.phone.trim()) {
        this.errors.emailPhone = 'Bitte geben Sie entweder Ihre E-Mail-Adresse oder Telefonnummer an.';
      } else {
        if (this.form.email && !this.validateEmail(this.form.email)) {
          this.errors.emailPhone = 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
        }
      }

      if (!this.form.message || this.form.message.trim().length < 4) {
        this.errors.message = 'Die Nachricht muss mindestens 4 Zeichen lang sein.';
      }

      return !this.errors.firstName && !this.errors.lastName && !this.errors.emailPhone && !this.errors.message;
    },

    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email.toLowerCase());
    },

    async handleSubmit() {
      const espoClient = this.useEspoClient();
      
      const interessent = {
        entityType: 'Lead',
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        emailAddress: this.form.email,
        phoneNumber: this.form.phone,
        description: this.form.message,
        source: '123db.at'
      };

      try {
        this.formSubmitting = true;
        await espoClient.post('', interessent);

        this.formSubmitted = true;
        localStorage.removeItem('contactForm');
      }
      catch (error) {
        console.error('Fehler beim Senden:', error);
      }
      finally {
        this.formSubmitting = false;
      }
    },

    onSubmit() {
      if (this.validateForm() && !this.formSubmitted && !this.formSubmitting) {
        this.handleSubmit();
      }
    },

    async redirect(urlId) {
        const espoClient = this.useEspoClient();

        try {
          this.redirecting = true;
          const response = await espoClient.get(`redirect/${urlId}`);
          this.redirecting = false;
          
          if (response?.url) {
            window.open(response.url, '_blank');
          }
        } 
        catch {
        // Fail silently.
      }
        finally {
          this.redirecting = false;
        }
      },

    scrollToContactForm() {
      document.getElementById('contactUs')?.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
</script>
<style>
</style>
